"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KasumahUintLogger__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "string",
                name: "key",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "add",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "string",
                name: "key",
                type: "string",
            },
        ],
        name: "all",
        outputs: [
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "string",
                name: "key",
                type: "string",
            },
        ],
        name: "length",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "string",
                name: "key",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "remove",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "bool",
                name: "isApproved",
                type: "bool",
            },
        ],
        name: "setApproved",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "string",
                name: "key",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "start",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "len",
                type: "uint256",
            },
        ],
        name: "slice",
        outputs: [
            {
                internalType: "uint256[]",
                name: "ids",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class KasumahUintLogger__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.KasumahUintLogger__factory = KasumahUintLogger__factory;
KasumahUintLogger__factory.bytecode = _bytecode;
KasumahUintLogger__factory.abi = _abi;
